import type { Image as ImageType } from 'types/capi/shared';

import Image, { smallImageOptions } from '~/components/Image';
import ModalNav from '~/components/Modals/ModalNav';

import AuthDialog from '../AuthDialog';

type Props = {
  children: React.ReactNode;
  heading: string;
  image?: ImageType;
  onBack?: () => void;
  onDismiss: () => void;
};

export default function ExitNotificationDialog({
  children,
  heading,
  image,
  onBack,
  onDismiss
}: Props) {
  return (
    <AuthDialog onDismiss={onDismiss}>
      <ModalNav heading={heading} hideDismiss onBack={onBack} />
      {image && (
        <Image
          className="aspect-video w-20 object-cover md:w-[182px]"
          src={image.url}
          alt={image.alt}
          loading="eager"
          {...smallImageOptions({ pad: true })}
        />
      )}
      <div className="flex w-full flex-col items-center gap-4 text-center">
        {children}
      </div>
    </AuthDialog>
  );
}
